// @ts-strict-ignore
import { Component } from "@angular/core";
import * as C from "../../../../../../shared/constants/globals.constants";
import { EWizDynamicBaseClassComponent } from "src/app/modules/esim/shared/classes/ewiz-dynamic.class";

@Component({
  selector: C.EWIZ_HIGHER_PRIORITY_PLMN_CONFIGURATION,
  templateUrl: "./higher-priority-plmn-configuration.component.html",
  standalone: false
})
export class EWizHigherPriorityPLMNConfigurationComponent extends EWizDynamicBaseClassComponent {
  constructor() {
    super();

    for (let i = 0x00; i < 0x50; i++) {
      if (i === 0x00) {
        this.searchPeriodOptionsSupported.push({
          label: $localize`No higher priority PLMN search attempts`,
          value: `${i}`
        });
      } else if (i === 0x01) {
        this.searchPeriodOptionsSupported.push({
          label: `2 ` + $localize`hours`,
          value: `${i}`
        });
      } else if (i >= 0x02 && i <= 0x28) {
        this.searchPeriodOptionsSupported.push({
          label: `${2 * i} ` + $localize`hours`,
          value: `${i}`
        });
      } else if (i >= 0x29 && i <= 0x50) {
        this.searchPeriodOptionsSupported.push({
          label: `${4 * i - 80} ` + $localize`hours`,
          value: `${i}`
        });
      }
    }

    for (let i = 0x00; i < 0x50; i++) {
      if (i === 0x00) {
        this.searchPeriodOptionsNotSupported.push({
          label: $localize`No higher priority PLMN search attempts`,
          value: `${i}`
        });
      } else if (i === 0x01) {
        this.searchPeriodOptionsNotSupported.push({
          label: "6 " + $localize`minutes`,
          value: `${i}`
        });
      } else if (i >= 0x02 && i <= 0x50) {
        this.searchPeriodOptionsNotSupported.push({
          label: `${6 * i} ` + $localize`minutes`,
          value: `${i}`
        });
      }
    }
  }

  searchPeriodOptionsSupported = [];
  searchPeriodOptionsNotSupported = [];

  updateUserEqipmentOption() {
    if (+this.profileValues.higherPriorityPLMN.supported === 0) {
      this.profileValues.higherPriorityPLMN.searchPeriod = { label: $localize`60 minutes`, value: "10" };
    } else if (+this.profileValues.higherPriorityPLMN.supported === 1) {
      this.profileValues.higherPriorityPLMN.searchPeriod = { label: $localize`72 hours`, value: "36" };
    }

    this.handleFormEvents();
  }
}
